// extracted by css-extract-rspack-plugin
export default {"main":"main-x6jqL2","link":"link-EtYmwP","container":"container-fZXyKT"};